// src/services/trackingService.js
import axios from 'axios';
import { createAuthHeaders } from '../utils/securityUtils';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

console.log('🔧 Configuración API:', {
  API_BASE_URL,
  exists: !!API_BASE_URL,
});

class TrackingService {
  constructor() {
    this.api = axios.create({
      baseURL: API_BASE_URL,
      timeout: 30000,
    });

    // Interceptor para agregar headers de autenticación a TODAS las peticiones
    this.api.interceptors.request.use(
      async (config) => {
        try {
          const method = config.method.toUpperCase();
          const path = config.url;

          console.log('🔐 Generando firma para:', { method, path });

          const authHeaders = await createAuthHeaders(method, path);

          // Agregar headers al request
          config.headers['X-API-Key'] = authHeaders['X-API-Key'];
          config.headers['X-Timestamp'] = authHeaders['X-Timestamp'];
          config.headers['X-Signature'] = authHeaders['X-Signature'];

          console.log('✅ Headers de seguridad agregados:', {
            timestamp: authHeaders['X-Timestamp'],
            signature: authHeaders['X-Signature'].substring(0, 10) + '...',
          });

          return config;
        } catch (error) {
          console.error('❌ Error generando headers de seguridad:', error);
          return Promise.reject(error);
        }
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }

  // ✅ Método existente - ahora con autenticación automática
  async getPreAuthInfo(trackingNumber) {
    try {
      console.log('📤 Enviando pre-auth a API:', {
        url: `${API_BASE_URL}/tracking/pre-auth`,
        trackingNumber,
      });

      const response = await this.api.get('/tracking/pre-auth', {
        params: { tracking_number: trackingNumber },
      });

      console.log('✅ Pre-auth exitoso:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error en pre-auth:', {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
        trackingNumber,
      });

      const errorMessage =
        error.response?.data?.detail ||
        error.response?.data?.error ||
        error.message ||
        'Error al verificar el número de tracking';
      throw new Error(errorMessage);
    }
  }

  // ✅ Método existente - ahora con autenticación automática
  async completeAuth(authCompleteRequest) {
    try {
      console.log('📤 Enviando auth completa a API:', {
        url: `${API_BASE_URL}/tracking/complete-auth`,
        payload: authCompleteRequest,
      });

      const response = await this.api.post(
        '/tracking/complete-auth',
        authCompleteRequest
      );

      console.log('✅ Auth completa exitosa:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error en auth completa:', {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
        authCompleteRequest,
      });

      const errorMessage =
        error.response?.data?.detail ||
        error.response?.data?.error ||
        error.message ||
        'Error al autenticar y obtener información';
      throw new Error(errorMessage);
    }
  }

  // ✅ Método legacy - ahora con autenticación automática
  async authenticateTracking(trackingNumber, authValue) {
    try {
      const payload = {
        tracking_number: trackingNumber,
        auth_value: authValue,
      };

      console.log('📤 Enviando request legacy a API:', {
        url: `${API_BASE_URL}/tracking/authenticate`,
        payload: payload,
      });

      const response = await this.api.post('/tracking/authenticate', payload);

      console.log('✅ Respuesta legacy exitosa:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error en trackingService legacy:', {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
        trackingNumber,
        authValue,
      });

      const errorMessage =
        error.response?.data?.detail ||
        error.response?.data?.error ||
        error.message ||
        'Error al consultar el tracking';
      throw new Error(errorMessage);
    }
  }

  async healthCheck() {
    try {
      const response = await this.api.get('/tracking/health');
      return response.data;
    } catch (error) {
      throw new Error('API no disponible');
    }
  }
}

export default new TrackingService();
